<template>
  <div class="row mx-3 justify-content-start">
    <span class="p-0 form-label align-self-start size-12">職種</span>
    <div class="w-100 m-0 p-0 d-flex flex-wrap">
      <div
        v-for="(occupation, idx) in props.occupations.flatMap((category) =>
          category.children?.map((children) => ({ categoryName: category.name, children }))
        )"
        :key="occupation?.children.id"
        class="mb-2 me-2 d-flex me-3 align-items-center col-auto p-0 mw-100"
      >
        <Field
          :id="`candidate_resume_occupations_${idx}`"
          :name="`candidate_resume_occupations[${idx}]`"
        >
          <div class="align-items-center col-auto d-flex flex-nowrap w-100">
            <p
              class="col-auto bg-silver-primary px-3 py-1 mb-0 border border-fourth rounded-2 me-1 text-truncate flex-shrink-1"
            >
              {{ occupation?.children.name }}
            </p>
            <img
              src="@/assets/image/icon-close-delete.svg"
              role="button"
              class="border rounded-circle border-third p-0d25"
              @click="onRemoveOccupation(occupation?.children.id)"
            />
          </div>
        </Field>
      </div>
      <div class="d-flex justify-content-center p-0 w-100 mt-2">
        <Button
          variant="primary"
          button-style="outlined"
          :custom-size="true"
          :rounded="false"
          class="mw-184x h-36x w-15 size-12 rounded-5 d-flex justify-content-center align-items-center"
          icon="plus"
          @click="addOccupations"
        >
          職種を追加する
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate';
import Button from '@/components/shared/button/Button.vue';

const onRemoveOccupation = (id: number): void => {
  emit('remove', id);
};

const addOccupations = (): void => {
  emit('open');
};

const props = defineProps({
  occupations: {
    type: Array as unknown as () => any,
    required: false,
  },
});

const emit = defineEmits(['open', 'remove']);
</script>
